import { ShopGoodAccessStatus } from "../../constants";

const getOrderShopGood = (order: any) => {
	return order.shop_good || order.shopGood || order.shopGoodStore || null;
};

export const getShopGoodCompareKey = (shopGood: any) => {
	const planId = Number(shopGood.shop_good_plans_id || 0);
	const instrumentId = Number(shopGood.instrument_id || 0);

	if (shopGood.grand_chart_id) {
		return `content:${planId}:${instrumentId}:${shopGood.grand_chart_id}`;
	}

	const title = String(shopGood.title || "")
		.trim()
		.toLowerCase();

	if (title) {
		return `content:${planId}:${instrumentId}:${title}`;
	}

	const rate = String(shopGood.rate || "")
		.trim()
		.toLowerCase();

	return `content:${planId}:${instrumentId}:${rate}`;
};

export const getShopGoodAccessState = (shopGood: any, activeOrders: any[] = []) => {
	const currentKey = getShopGoodCompareKey(shopGood);
	const currentPeriodId = Number(shopGood.shop_good_period_id);

	console.log("ACCESS DEBUG current", {
		shopGoodId: shopGood.id,
		currentKey,
		currentPeriodId,
		shopGood,
	});

	activeOrders.forEach((order) => {
		const activeGood = getOrderShopGood(order);
		console.log("ACCESS DEBUG order", {
			orderId: order.id,
			orderShopGoodId: order.shop_good_id,
			activeGood,
			activeGoodKey: activeGood ? getShopGoodCompareKey(activeGood) : null,
			activePeriodId: activeGood ? Number(activeGood.shop_good_period_id) : null,
		});
	});

	const samePlanOrder = activeOrders.find((order) => {
		const activeGood = getOrderShopGood(order);

		if (!activeGood) {
			return false;
		}

		return getShopGoodCompareKey(activeGood) === currentKey;
	});

	if (!samePlanOrder) {
		return {
			status: ShopGoodAccessStatus.Available,
			activeUntil: null,
			order: null,
		};
	}

	const activeGood = getOrderShopGood(samePlanOrder);
	const activePeriodId = Number(activeGood.shop_good_period_id);

	if (activePeriodId === currentPeriodId) {
		return {
			status: ShopGoodAccessStatus.Active,
			activeUntil: samePlanOrder.date_end,
			order: samePlanOrder,
		};
	}

	if (activePeriodId === 2 && currentPeriodId === 1) {
		return {
			status: ShopGoodAccessStatus.CoveredByAnnual,
			activeUntil: samePlanOrder.date_end,
			order: samePlanOrder,
		};
	}

	if (activePeriodId === 1 && currentPeriodId === 2) {
		return {
			status: ShopGoodAccessStatus.UpgradeToAnnual,
			activeUntil: samePlanOrder.date_end,
			order: samePlanOrder,
		};
	}

	return {
		status: ShopGoodAccessStatus.Available,
		activeUntil: null,
		order: null,
	};
};
